// extracted by mini-css-extract-plugin
export var body = "_2h-8";
export var button = "_2h-0";
export var closeButton = "_2h-5";
export var content = "_2h-3";
export var empty = "_2h-f";
export var grid = "_2h-c";
export var header = "_2h-4";
export var icon = "_2h-1";
export var option = "_2h-d";
export var optionSelected = "_2h-e";
export var overlay = "_2h-2";
export var searchIcon = "_2h-a";
export var searchInput = "_2h-b";
export var searchWrapper = "_2h-9";
export var title = "_2h-6";
export var visuallyHidden = "_2h-7";